import {ResolvedPlanApproval} from '../ResolvedPlanApproval'
import type {PlanApprovalItem} from '../../../types/events'
import type {PlanResolution} from '@github-ui/copilot-shared-ui/ahp/interactive-prompt-types'

/**
 * Renders a resolved plan approval prompt in the timeline.
 */
export function PlanApproval({item}: {item: PlanApprovalItem}) {
  if (!item.completedEvent) return null

  const resolution: PlanResolution = {
    approved: item.completedEvent.data.approved ?? false,
    selectedAction: item.completedEvent.data.selectedAction,
    feedback: item.completedEvent.data.feedback,
  }

  return <ResolvedPlanApproval resolution={resolution} summary={item.summary} />
}
